<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="Status === 2 || !canWrite">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="handleDelete" :disabled="!isSave || Status === 2 || !canWrite">删除</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="reView" v-if="Status !== 2" :disabled="!isSave || !canReview">审核</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="cancelReView" v-if="Status === 2" :disabled="!isSave || !canReview">弃审</el-button>
        <!-- <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="!isSave">
            联查<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item"
              >采购订单情况</el-dropdown-item
            >
            <el-dropdown-item class="dropdown-item">盘点单情况</el-dropdown-item>
            <el-dropdown-item class="dropdown-item"
              >组装拆卸单情况</el-dropdown-item
            >
            <el-dropdown-item class="dropdown-item"
              >形态转换单情况</el-dropdown-item
            >
            <el-dropdown-item class="dropdown-item">凭证情况</el-dropdown-item>
            <el-dropdown-item class="dropdown-item">其他出库单</el-dropdown-item>
            <el-dropdown-item class="dropdown-item">调拨单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave">打印</el-button>
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>
      <el-form :model="data" ref="form" :inline="true" :line-form="true" label-width="100px" status-icon>
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期:" required>
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px"
              @change="(v) => getPreviewNo(v)">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" required>
            <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span>
            <el-input style="width: 180px" v-else v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="出库类别:" required>
            <type-outselect ref="typeOutSelect" :disabledStatus="Status" v-model="data.OutClassId" style="width: 180px" />
          </el-form-item>
          <!-- <el-form-item label="入库类别" required>
            <type-inselect ref="typeInSelect"  :disabledStatus="Status" v-model="data.InClassId" />
          </el-form-item> -->
          <el-form-item label="业务类型:">
            <span class="not-edit" style="width: 180px" v-if="Status === 2">{{
              data.BusinessType
            }}</span>
            <!-- <business-select
              v-else
              v-model="data.BusinessTypeId"
              style="width: 190px"
            /> -->
            <el-select v-else v-model="data.BusinessTypeId" style="width: 180px">
              <el-option @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType"
                :value="item.BusinessTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库:" required>
            <span class="not-edit" v-if="Status === 2">{{
              data.WarehouseName
            }}</span>
            <el-select v-else style="width: 180px" @change="changeDataSiteWarehouse" v-model="data.WarehouseId">
              <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="制单人:">
            <span class="span" style="width: 180px">{{ data.MakeEmpName }}</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="100px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" :disabled="Status === 2"
                style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table border class="table_bottom table-line tb-c-head" :data="tableData" :row-class-name="tableRowClassName" stripe style="margin-top: 18px" @row-click="add"
        v-keymove="newLine" v-if="showDetail">
        <el-table-column min-width="160" align="center" label="备注" v-if="showField('备注')">
          <template slot-scope="{ row }">
            <span v-if="Status === 2">{{ row.Remark }}</span>
            <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
          </template>
        </el-table-column>
        <el-table-column label="仓库" prop="WarehouseId" align="center" min-width="120" v-if="showField('仓库')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.WarehouseName }}</span>
            <el-select v-else v-model="row.WarehouseId" @change="changeWarehouse($event, row)">
              <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <!-- h -->
        <el-table-column
                prop="WarehousePositionId"
                label="库位"
                min-width="120"
                v-if="showField('仓库')"
              >
                <template slot-scope="{ row }">
                  <el-select v-model="row.WarehousePositionId" @visible-change="onChangeWarehousePosition($event,row,row.WarehouseId)" clearable>
                    <el-option
                      v-for="item in row.WarehousePositionList"
                      :key="item.WarehousePositionId"
                      :label="item.WarehousePositionName"
                      :value="item.WarehousePositionId"
                    ></el-option>
                  </el-select>
                </template>
        </el-table-column>

        <el-table-column label="存货编码" prop="ProductNo" align="center" min-width="160" v-if="showField('存货编码')">
        </el-table-column>
        <el-table-column label="存货名称" prop="ProductName" align="center" min-width="100" v-if="showField('存货名称')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
            <account-select v-else v-model="row.ProductName" :source="DAccount" @select="onSelect($event, row)" :pageSize="pageParams.pageSize" :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal" @inputText="inputText($event, row)" @click.native="resetFun" @currentPage="currentPage($event, row)" :pageType="true" />
          </template>
        </el-table-column>
        <el-table-column align="left" label="批号" min-width="300px" v-if="showField('批号')">
          <template slot-scope="{ row, $index }">
            <span v-if="!row.ProductName" style="color:#999;">请先选择存货</span>
            <span class="not-edit" v-else-if="Status === 2">{{ row.BatchNumber }}</span>
            <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
            <account-select v-else 
              v-model="row.BatchNumber" 
              :Head='Head'
              :source="batchList"
              :listTotal="batchListTotal" :pageType="true" 
              :pageSize="batchPageParams.pageSize" :pageIndex="batchPageParams.pageIndex"
              @select="onSelBatch($event, row, $index)" 
              @inputText="inputTextBatch($event, row)" 
              @click.native="onOpenBatch($event, row, $index)" 
              @currentPage="currentPageBatch($event, row)" 
              keyword="BatchNumber"/>
          </template>
        </el-table-column>
        <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100" v-if="showField('规格型号')">
        </el-table-column>
        <el-table-column label="属性" prop="PropertyId" align="center" min-width="100" key="table1_6" v-if="showField('属性')">
          <template slot-scope="{ row }">
            <el-select v-if="row.UseProcess && Status !== 2" v-model="row.PropertyId" @change="changeProperty($event, row)">
              <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{
              row.UseProcess ? row.PropertyName : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="ColorId" align="center" min-width="100" key="table1_7" v-if="showField('颜色')">
          <template slot-scope="{ row }">
            <el-select v-if="row.UseColor && Status !== 2" v-model="row.ColorId" @change="changeColor($event, row)">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId" :disabled="item.Status==0"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{
              row.UseColor ? row.ColorName : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="计量单位" min-width="120px" v-if="showField('计量单位')">
          <template slot-scope="{ row, $index }">
            <el-select v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true" v-model="row.UnitId" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
            </el-select>
            <span v-else>{{ row.UnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
          <template slot-scope="{ row, $index }">
            <!-- <span>{{ row }}{{ $index }}</span> -->
            <el-select v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true" v-model="row.UnitId2" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
            </el-select>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else>{{ row.UnitName2 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="center" min-width="100" key="table1_9" v-if="showField('数量')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
            <el-input type="text" v-else @change="changeQuantity($event, row, $index)" v-model="row.Quantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="数量2" prop="Quantity2" align="center" min-width="100" v-if="showField('数量2')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Quantity2"
              @change="changeQuantity2($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="换算率" v-if="showField('换算率')">
          <template slot-scope="{ row, $index }">
            <span v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1">{{ row.Rate }}</span>
            <span v-else-if="row.UnitType == 0"></span>
            <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="Price" align="center" min-width="100" key="table1_10" v-if="canPrice&&showField('单价')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
            <el-input type="text" v-else @change="changePrice($event, row)" v-model="row.Price"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价2" prop="Price2" align="center" min-width="100" v-if="canPrice&&showField('单价2')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="Amount" align="center" min-width="100" key="table1_11" v-if="canPrice&&showField('金额')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
            <el-input type="text" v-else @change="changeAmount($event, row)" v-model="row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="del(row, $index)" :disabled="Status === 2">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import accountSelect from "@/components/business/stock/select";
import optionMixins from "@/mixins/option";
import typeOutselect from "./outSelect";
import typeInselect from "./inSelect";
import fieldDialog from "@/components/common/fieldDialog"
export default {
  mixins: [optionMixins],
  name: "editotheroutbound",
  components: {
    accountSelect,
    typeOutselect,
    typeInselect,
    fieldDialog,
  },
  data() {
    return {
      keepData: [],
      pdApi: require("@/api/ba/product").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/stock/stOutDoc").default,
      propertyApi: require("@/api/ba/property").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      docSetting_api: require('@/api/sy/docSetting').default,
      warehousePositionApi: require("@/api/ba/warehousePosition").default, //hqq
      propertyList: [],
      Mode: 0,
      businessTypeList: [],
      warehouseList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      isSave: false,
      data: {
        DocId: 0,
        OutType: 23,
        DocDate: this.$commonJs.getToday(),
        DocNo: "",
        BusinessTypeId: "",
        WarehouseId: "",
        MinusEntry: "",
        EmpName: "",
        EmpId: 0,
        MakeEmpName: "",
        OutClassId: 0,
        MakeEmpId: 0,
        ReviewEmpName: "",
        ReviewEmpId: 0,
        ReviewTime: "",
        BusinessTypeNo: "",
        BusinessType: "",
        Remark: "",
      },
      Status: 0,
      date: [],
      tableData: [
        {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          WarehouseId: null,
          WarehouseName: "",
          ProductId: null,
          ProductNo: "",
          ProductName: "",
          ProductSpec: "",
          PropertyId: null,
          PropertyName: "",
          ColorId: null,
          ColorName: "",
          UnitId: null,
          UnitName: "",
          Quantity: null,
          Price: null,
          Amount: null,
          Units: [],

          UnitId2: null,
          UnitName2: "",
          Quantity2: null,
          Price2: null,
          Rate: null,
          Remark: "",
          BatchNumber:'',

          WarehousePositionId: null, //hqq
        },
      ],
      viewType: "create",
      delTableData: [],
      isUseProcess: true,
      isUseColor: true,
      detailFields: [],
      showDetail: false,
      Head:[
        { Value: "BatchNumber", Name: "批号", Width: "180" },
        { Value: "WarehouseName", Name: "仓库", Width: "100" },
        { Value: "ColorName", Name: "颜色", Width: "80" },
        { Value: "PropertyName", Name: "属性", Width: "80" },
        { Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        { Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: "BaseUnitName", Name: "主单位", Width: "80" }, 
        { Value: "BaseQuantity", Name: "现存量", Width: "80" }
      ],
      batchListTotal:0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      batchList:[]
    };
  },
  created() {
    this.init();
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/otheroutbound");
    },
    canWrite() {
      return this.$permission.canWrite("/business/stock/otheroutbound");
    },
    canReview() {
      return this.$permission.canReview("/business/stock/otheroutbound");
    },
  },
  mounted() {
    this.viewType = this.$route.params.type;
    this.$refs.typeOutSelect.init();
    // this.$refs.typeInSelect.init();
    if (this.$route.params.type === "create") {
      this.getPreviewNo();
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: "其它出库单", Url: "business/stock/otheroutbound/edit" });
      })
    },
    setTbField() {
      this.showDetail = false;
      this.docSetting_api.list({ DocType: "其它出库单", IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey);
          this.$nextTick(() => {
            this.showDetail = true;
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1;
    },
    changeDataSiteWarehouse(val) {
      let item = this.warehouseList.filter((item) => {
        return item.value === val;
      })[0];
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].T !== 0) {
          this.tableData[i].T = 1
        }
        this.tableData[i].WarehouseId = item.value,
          this.tableData[i].WarehouseName = item.label
      }
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        WarehouseId: null,
        WarehouseName: "",
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        UnitId: null,
        UnitName: "",
        Quantity: 0,
        Price: 0,
        Amount: 0,
        Units: [],
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableData.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableData));
      this.tableData = [];
      this.$nextTick(() => {
        this.tableData = copy;
      });
      console.log("this.tableData", this.tableData);
    },
    init() {
      this.propertyApi
        .list({
          Status: 1,
        })
        .then((res) => {
          if (res.Code === 0) {
            this.propertyList = res.Data;
          }
        });

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize,
        })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });

      this.warehouseApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.WarehouseId = res.Data[0].WarehouseId;
            this.data.WarehouseName = res.Data[0].WarehouseName;
          }
          this.warehouseList = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });

      this.sourceTypeApi.list({}).then((res) => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data;
          let params = "其它出库单";
          let index = this.SourceTypeIdArr.findIndex(
            (item) => item.SourceType == params
          );
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId;
          this.data.OutType = SourceTypeId;
          this.businessTypeApi
            .getSourceTypeToBusinessType(SourceTypeId)
            .then((res) => {
              if (res.Code == 0) {
                this.businessTypeList = res.Data;
                if (this.viewType !== "edit") {
                  this.data.BusinessTypeId =
                    this.businessTypeList[0].BusinessTypeId;
                  this.data.BusinessType =
                    this.businessTypeList[0].BusinessType;
                  this.data.MinusEntry = this.businessTypeList[0].MinusEntry;
                  this.changeNumber(this.data.MinusEntry);
                } else {
                  console.log(
                    "this.data.BusinessTypeId",
                    this.data.BusinessTypeId
                  );
                  let item = this.businessTypeList.filter((item) => {
                    return item.BusinessTypeId === this.data.BusinessTypeId;
                  })[0];

                  console.log("item", item);

                  this.data.MinusEntry = item.MinusEntry;

                  this.changeNumber(this.data.MinusEntry);
                }
              }
            });
        }
      });

      this.callOptionApi();
      this.setTbField();
    },
    BusinessChange(val) {
      this.data.BusinessTypeId = val.BusinessTypeId;
      this.data.MinusEntry = val.MinusEntry;
      this.data.BusinessType = val.BusinessType;
      this.changeNumber(this.data.MinusEntry);
    },
    changeNumber(status) {
      if (status) {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity;
          item.Quantity2 =
            item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2;
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity,item.Price);

          if (item.T !== 0) {
            item.T = 1;
          }
        });
      } else {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity);
          item.Quantity2 = item.Quantity2 == null ? item.Quantity2 : Math.abs(item.Quantity2);
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity,item.Price);

          if (item.T !== 0) {
            item.T = 1;
          }
        });
      }
    },
    editInit(data, type = 'edit') {
      this.viewType = "edit";
      this.isSave = true;
      let {
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        OutType,
        MakeEmpId,
        MakeEmpName,
        Products,
        Remark,
        OutClassId,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        Status,

        WarehouseId,
        WarehouseName,
      } = data;

      this.data = {
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        OutType,
        MakeEmpId,
        OutClassId,
        MakeEmpName,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        WarehouseId,
        WarehouseName,
      };

      this.Status = Status;

      Products.forEach((item, index) => {
        item.T = null;
        item.IsBatchNumber = item.BatchNumber ? true : false
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null;
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null;
        item.WarehouseId = item.WarehouseId !== 0 ? item.WarehouseId : null;
        item.UnitId = item.UnitId !== 0 ? item.UnitId : null;

        if (item.Units.length === 0 || item.Units == null) {
          item.UnitType = 0;
        } else {
          item.UnitType = 1;
          let UnitItem = item.Units.filter((v) => {
            return item.UnitId === v.UnitId;
          })[0];
          item.IsMain = UnitItem.IsMain;
          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })
        }
        if (type == 'keep') {
          item.ChangeType = this.keepData[index].ChangeType;
        }

        item.WarehousePositionList = [{ WarehousePositionId: item.WarehousePositionId, WarehousePositionName: item.WarehousePositionName, }]; //hqq
      });

      this.tableData = Products;
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("其它出库单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取其它出库单编号失败");
        }
      });
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1;

      this.editT(row);

      let lastIsMain = row.IsMain;
      this.tableData[index].IsMain = data.IsMain;
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex, data.Rate);
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity;
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate));
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1);

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity));
      row.Price = this.getPrice(val);

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2));
      row.Price2 = this.getPrice(val);
    },
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 =
        this.tableData[index].Units[findIndex].UnitId;
      this.tableData[index].UnitName2 =
        this.tableData[index].Units[findIndex].UnitName;
      // this.tableData[index].ChangeType2 =
      //   this.tableData[index].Units[findIndex].ChangeType;

      if (Rate > 0) {
        this.tableData[index].Rate = Rate;
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;

      this.editT(row);

      let lastIsMain = row.IsMain;
      if (data.IsMain) {
        this.tableData[index].IsMain = false;
      } else {
        this.tableData[index].IsMain = true;
      }
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        }
      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex, data.Rate);
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.Quantity = row.Quantity2;
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(2);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate));
        }
      }
      this.changeQuantity2(this.tableData[index].Quantity2, row, index, 1);

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity));
      row.Price = this.getPrice(val);

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2));
      row.Price2 = this.getPrice(val);
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId =
        this.tableData[index].Units[findIndex].UnitId;
      this.tableData[index].SaUnitName =
        this.tableData[index].Units[findIndex].UnitName;
      // this.tableData[index].ChangeType1 =
      //   this.tableData[index].Units[findIndex].ChangeType;

      if (Rate > 0) {
        this.tableData[index].Rate = Rate;
      }
    },
    changeQuantity(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      this.editT(row);

      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity;
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.Quantity = Math.abs(row.Quantity);
        row.Quantity2 = Math.abs(row.Quantity2);
        data = Math.abs(data)
      }
      if (row.T == 3) this.tableData[index].T = 1;
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(2);
          //row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate));
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity);
          }
        } else {
          //row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity / row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity);
          }
          // if (row.ChangeType1 == 1 && row.Quantity2 != 0) {
          //   row.Rate = Math.abs(Number(row.Quantity2 / data)).toFixed(2);
          //   if (type === 0) {
          //     let val = this.setNumber(Math.abs(row.Amount / data));
          //     row.Price = this.getPrice(val);
          //   }
          // } else if (row.Quantity2 == 0) {
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          //   if (type === 0) {
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // } else if (row.ChangeType1 == 0) {
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          //   if (type === 0) {
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // }
        }
      } else {
        row.Quantity2 = row.Quantity;
        row.Amount = this.setAmount(row.Price, row.Quantity);
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      this.editT(row);
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity;
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.Quantity = Math.abs(row.Quantity);
        row.Quantity2 = Math.abs(row.Quantity2);
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(2);
          if (row.HasGrammage == true) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(data / row.Quantity)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data));
            row.Price2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2/换算率");
          // row.Quantity=Number(data/row.Rate).toFixed(2);
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2);
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(2);
          if (row.HasGrammage == true) {
            row.Quantity = this.getQuantity(data / row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(row.Quantity / data)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data));
            row.Price2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2*换算率");
          // row.Quantity=Number(data*row.Rate).toFixed(2);
          row.Quantity = this.getQuantity(data * row.Rate);
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2);
          }
        }
      }
    },
    changePrice(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      row.Price = this.getPrice(val);
      row.Amount = this.setAmount(row.Price, row.Quantity);

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(row.Amount / row.Quantity2);
      }
    },
    changePrice2(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      row.Price2 = this.getPrice(val);

      row.Amount = this.setAmount(row.Price2, row.Quantity2);
      if (row.Quantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.Quantity);
      }
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      row.Rate = data;
      row.Rate = Number(row.Rate).toFixed(2);
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(2);
        if(row.HasGrammage==true){
          row.Quantity2 = this.getQuantity(row.Quantity * Number(data));
        }else{

          row.Quantity2 = this.getQuantity(row.Quantity / Number(data));
        }
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(2);
        if(row.HasGrammage==true){
          row.Quantity = this.getQuantity(row.Quantity2 * Number(data));
        }else{

          row.Quantity = this.getQuantity(row.Quantity2 / Number(data));
        }
      }

      let val = this.setNumber(row.Amount / row.Quantity);
      row.Price = this.getPrice(val);

      val = this.setNumber(row.Amount / row.Quantity2);
      row.Price2 = this.getPrice(val);
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(2));
    },
    changeAmount(val, row) {
      this.editT(row);

      if (this.data.MinusEntry) {
        val = val > 0 ? 0 - val : val;
      } else {
        val = Math.abs(val);
      }
      row.Amount = this.setNumber(val);

      if (row.Quantity !== 0) {
        row.Price = this.getPrice(Math.abs(row.Amount / row.Quantity));
      } else {
        this.$message({ type: "warning", message: "实收数量不能为0" });
        row.Amount = 0;
        return;
      }

      if (row.Units.length > 0) {
        if (row.Quantity2 !== 0) {
          row.Price2 = this.getPrice(Math.abs(row.Amount / row.Quantity2));
        } else {
          this.$message({ type: "warning", message: "实收数量2不能为0" });
          row.Amount = 0;
          return;
        }
      }


    },
    changeBusinessType(val) {
      let item = this.businessTypeList.filter((item) => {
        return val === item.BusinessTypeId;
      })[0];

      this.data.BusinessTypeId = item.BusinessTypeId;
      this.data.BusinessTypeNo = item.BusinessTypeNo;
      this.data.BusinessType = item.BusinessType;
    },
    changeColor(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;
    },
    changeProperty(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
    },
    changeWarehouse(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.warehouseList.filter((item) => {
        return item.value === val;
      })[0];

      row.WarehouseName = item.label;

      this.onSiteWarehouse(val, row); //hqq
    },
    changeUnit(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = row.Units.filter((item) => {
        return item.UnitId === val;
      })[0];

      row.UnitName = item.UnitName;
    },
    onSelect(e, row) {
      console.log("🚀 ~ onSelect ~ e:", e)
      row.Grammage= e.Grammage,
      row.HasGrammage= e.HasGrammage,
      row.Variable= e.Variable
      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchNumber = null
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
      row.Colors = [];
      row.Units = [];
      row.WarehouseId = this.data.WarehouseId;
      row.WarehouseName = this.data.WarehouseName;
      row.UnitName = "";
      row.ColorName = "";

      row.ColorId = null;
      row.PropertyId = null;

      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.Colors = e.Colors;
      row.Units = e.Units;

      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;

      row.UnitId = e.SkUnitId;
      row.ChangeType = 0;
      row.UnitType = 0;


      if (e.Units.length === 0) {
        row.UnitId = e.SkUnitId;
        row.UnitName = e.SkUnitName;
      } else {
        row.UnitType = 1;
        e.Units.forEach((item) => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
        });
        if (row.UnitId) {
          let index = this.getUnitIndex(3, e.Units, row.UnitId);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;
          row.UnitName=data.UnitName;
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = assistData.Rate.toFixed(5);
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = data.Rate.toFixed(5);
          }
          row.UnitId2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = noMainData[0].Rate.toFixed(5);
          row.IsMain = true;
        }

      }
    },
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val;
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text, row) {
      row.ProductName = text;
      this.pdApi
        .list({ pageIndex: 1, pageSize: 7, ProductName: text, Status: 1, })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    openPage() {
      this.$router.push({
        name: "workList",
      });
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          row.PropertyId = row.PropertyId ? row.PropertyId : 0;
          row.ColorId = row.ColorId ? row.ColorId : 0;
          row.WarehouseId = row.WarehouseId ? row.WarehouseId : 0;
          row.UnitId = row.UnitId ? row.UnitId : 0;
          this.delTableData.push(row);
        }

        this.tableData.splice(index, 1);
        if (this.tableData.length === 0) {
          this.newLine();
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    newLine() {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        WarehouseId: null,
        WarehouseName: "",
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        UnitId: null,
        UnitName: "",
        Quantity: null,
        Price: null,
        Amount: null,
        Units: [],

        UnitId2: null,
        UnitName2: "",
        Quantity2: null,
        Price2: null,
        Rate: null,
        Remark: "",        
        WarehousePositionId: null, //hqq
      };

      this.tableData.push(o);
    },
    add(row, column) {
      if (column.label === "操作" || this.Status === 2) {
        return;
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine();
      }
    },
    reView1() {
      let id = this.data.DocId;
      this.api.examine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId;
      this.api.cancelExamine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    handleDelete() {
      let Id = this.data.DocId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({ Id }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
    getProducts(data) {
      let Products = [];
      data.forEach((item) => {
        let {
          T,
          DocId,
          DocProductId,
          WarehouseId,
          WarehouseName,
          ProductId,
          ProductNo,
          ProductName,
          ProductSpec,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          UnitId,
          UnitName,
          Quantity,
          Price,
          Amount,

          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          Rate,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          BatchNumber,

          WarehousePositionId, //hqq
        } = item;

        PropertyId = PropertyId ? PropertyId : 0;
        ColorId = ColorId ? ColorId : 0;
        WarehouseId = WarehouseId ? WarehouseId : 0;
        UnitId = UnitId ? UnitId : 0;
        Price = Price ?? 0;
        Amount = Amount ?? 0;

        let o = {
          T,
          DocId,
          DocProductId,
          WarehouseId,
          WarehouseName,
          ProductId,
          ProductNo,
          ProductName,
          ProductSpec,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          UnitId,
          UnitName,
          Quantity,
          Price,
          Amount,

          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          Rate,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          BatchNumber,
          WarehousePositionId, //hqq
        };

        Products.push(o);
      });

      return Products;
    },
    save(type = 0) {
      //验证表单是否填写
      let yanzheng = ["DocDate", "DocNo", "BusinessTypeId", "WarehouseId"];
      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: "warning", message: "表单未填写完整" });
          return;
        }
      }

      let Products = this.getProducts(this.tableData);
      this.keepData = Products;
      if (Products.length > 0 && Products[0].ProductName != "") {
      } else {
        this.$message({ type: "warning", message: "明细列表不能为空" });
        return;
      }
      Products = Products.concat(this.delTableData);

      Products = Products.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });
      const sub = JSON.parse(JSON.stringify(Products))
      // 等于空设置为0
      sub.forEach(item => {
        Object.keys(item).forEach(key => {
          if (item[key] == null && key !== 'BatchStartDate' && key !== 'BatchNumber') {
            item[key] = 0;
          }
        })
      })

      let ProductsLength = sub.length;
      for (let i = 0; i < ProductsLength; ++i) {
        if (Products[i].UseColor && Products[i].ColorId === 0) {
          this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
          return;
        }
        // if (Products[i].UseProcess && Products[i].PropertyId === 0) {
        //   this.$message.error(`存货${Products[i].ProductName}未填写属性`)
        //   return;
        // }
        if (!sub[i].Quantity) {
          this.$message({ type: "warning", message: "存货数量需要大于0" });
          return;
        }
      }

      let o = {
        Products: sub,
        ...this.data,
      };

      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === "create") {
            this.data.DocId = res.Data;
          }
          if (type !== 1) {
            this.$message.success(res.Msg);
          }
          this.isSave = true;

          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              if (type === 1) {
                this.reView1()
              } else {
                this.editInit(res.Data, 'keep');
              }

            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.isSave = false;
      }
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      this.batchPageParams.pageIndex = 1;
      let o = {
        IsInOut:1,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 选择批号 */
    onSelBatch(e, row, index){
      if (row.T !== 0) {
        row.T = 1
      }
      if(e.BatchNumber !== row.BatchNumber){
        this.tableData[index].BatchNumber = e.BatchNumber
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text;
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut:1,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        BatchNumber:row.BatchNumber,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val;
      let o = {
        IsInOut:1,
        WarehouseId:row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        ProductName:row.ProductName,
        pageIndex: val,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },

    //hqq
    /** 预入出仓库 切换时 赋值预入库位 */
    onSiteWarehouse(val, row){
      row.WarehousePositionId = null;
    },
    onChangeWarehousePosition(e,row,id){
      if (id === null){
        return;
      }

      if(e){
        const o = {Status:1,WarehouseId:id}
        this.warehousePositionApi.list(o).then(res => {
          let list = res.Data.map(item => {
            return {
              WarehousePositionId: item.WarehousePositionId,
              WarehousePositionName: item.WarehousePositionName,
            }
          })
          this.$nextTick(()=>{
            // row.WarehousePositionList = list;
            this.$delete(row,'WarehousePositionList');
            this.$set(row,'WarehousePositionList',list);
          })
        })
      }
    },  
    //hqq

  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}
</style>
